import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'app/store/rootReducer';
import { getBulbMessage } from 'app/store/data/formsConfig';
import { DictionaryEntry } from 'app/services/dict.service';
import { FormsEnum } from 'app/shared/enums';
import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';

export function useRadioGroupControl({
  dictionary,
  input,
  onClick,
  onValueChange,
  meta: { touched, valid },
  formName,
  questionKey,
}: WrappedControlProps) {
  const error = touched && !valid;
  const isCepikModal = formName === FormsEnum.CompareCepikDataForm;

  const bulbInfoMessage = useSelector((state: RootState) =>
    formName ? getBulbMessage(state, formName, questionKey) : undefined
  );

  const handleChange = (value: string | boolean) => {
    const controlValue =
      value === 'true' ? true : value === 'false' ? false : value;

    if (input.value !== value) {
      input.onChange(controlValue);

      if (onValueChange) {
        onValueChange(controlValue, true);
      }
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const renderRadioButtons = (
    renderItemFunction: (entry: DictionaryEntry) => JSX.Element
  ) => dictionary && dictionary.map(renderItemFunction);

  const setDefault = () => {
    const selectedEntry =
      dictionary && dictionary.find((entry) => Boolean(entry.selected));

    if (!selectedEntry || isCepikModal) {
      return;
    }

    if (!input.value) {
      input.onChange(selectedEntry.key);
    }
  };

  useEffect(
    setDefault,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dictionary, input]
  );

  return {
    error,
    bulbInfoMessage,
    handleChange,
    handleClick,
    renderRadioButtons,
  };
}
